// Adjustable UI settings for the iOS-style lock screen
// Edit these values to tweak spacing/sizes without touching component code

const lockScreenConfig = {
  // Logo size in pixels
  logoSizeMobile: 256,   // e.g., 256px
  logoSizeDesktop: 320,  // e.g., 320px

  // Vertical spacing (margin-top) in pixels
  titleOffsetMobile: 300,   // distance from top area to the titles
  titleOffsetDesktop: 280,

  sliderOffsetMobile: -100,   // spacing from titles to the slider
  sliderOffsetDesktop: 32,
};

export default lockScreenConfig;


